module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/4_4b5489dcf7d347bf6a45c798afbe9979.png";